// Taşeron portalı — self-profil (`GET /supplier/me`) TanStack Query anahtarı
// (api-contract §18.2). Supplier **çok-firmalı** olabilir; aktif firma switcher ile
// değişir (`principal.companyId`). Anahtar aktif firmayı içerir → firma değişince
// sorgu otomatik yeniden çekilir (companyName taze kalır). `supplierUserId` de anahtardadır: oturum logout dışı
// bir yolla (refresh başarısız) düşüp aynı firmada başka kullanıcı girse bile önceki kullanıcının
// profili önbellekten sunulmaz.

export const meKeys = {
  /** Giriş yapan taşeron personelinin kendi profili + aktif firma (`GET /supplier/me`). */
  me: (companyId: number | null | undefined, supplierUserId: number | null | undefined) =>
    ['supplier', 'me', companyId ?? null, supplierUserId ?? null] as const,
} as const;
